import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Form,
  Row,
  Input,
  Col,
  Card,
  Table,
  Grid,
  Spin,
  Button,
  Space,
} from "antd";

//import { Input as InputDsGov, Button, Group, Card as CardDsGov, Row, Col as ColDsgov } from "react-dsgov";

import { ExpandAltOutlined, EditOutlined, ClearOutlined, SearchOutlined } from "@ant-design/icons";
import type { AlignType } from 'rc-table/lib/interface';

import { maskCnpj, maskCodigo, maskNumeroProcesso, numberOnly } from "../../../utils/maskFunctions";

import { useNavigate } from "react-router-dom";
import { errorMessage, infoMessage, mostrarInfo, mostrarInfoDetail } from "../../../messages/messages";
import type { IEfpc } from "../../../components/Interfaces";
import { apiEntidade, type IErroApi } from "../../../services/api";
import { hasAnyPermissao, hasPermissao, Papel } from "../../../components/auth/entidadeUsuario";
import { pushToBase } from "../../../utils/utilsFunctions";


const { useBreakpoint } = Grid;

const Consultar: React.FC<any> = () => {

  const navigate = useNavigate();

  const [form] = Form.useForm();

  const screens = useBreakpoint();

  const { tipo } = useParams();

  const [efpcs, setEfpcs] = useState<IEfpc[]>([]);
  const [efpcSelecionada, setEfpcSelecionada] = useState<IEfpc>();
  const [efpcSelecionadaParaOperacao, setEfpcSelecionadaParaOperacao] = useState<IEfpc>();
  const [serieEfpcSelecionadaParaOperacao, setSerieEfpcSelecionadaParaOperacao] = useState(0);

  const [totalElements, setTotalElements] = useState(0);
  const [linhaPorPagina, setLinhaPorPagina] = useState(10);
  const [pagina, setPagina] = useState(1);

  const [loading, setLoading] = useState(false);
  const [tipLoading, setTipLoading] = useState("");
  const [tipoConsulta, setTipoConsulta] = useState("");

  const [manter, setManter] = useState(0); // ESTADOS PARA PASSAR PARA A TELA SEGUINTE - 0: Operações / 2 : Detalhar / 3 : Alterar; 

  const [erroApi, setErroApi] = useState<IErroApi>()
  const [estadoErroApi, setEstadoErroApi] = useState(0)
  const [msgErroApi, setMsgErroApi] = useState("")

  useEffect(() => {
    window.scrollTo(0, 0)
    if (!hasAnyPermissao())
      pushToBase(navigate);
  }, []);

  useEffect(() => {
    if (erroApi && estadoErroApi > 0) {
      //console.log(estadoErroApi);
      //console.log(erroApi);
      if (estadoErroApi === 400) {
        mostrarInfoDetail("Erro de Requisição", erroApi);
      } else if (estadoErroApi === 401) {
        mostrarInfo("Erro de Acesso", "Não autorizado. Tente fazer o login novamente. Mensagem do servidor: " + msgErroApi);
      } else if (estadoErroApi === 403) {
        mostrarInfo("Erro de Acesso", "O acesso ao recurso é proibido. Mensagem do servidor: " + msgErroApi);
      } else {
        mostrarInfo("Erro de comunicação", "Verifique na opção consulta se o cadastro foi efetivado. Mensagem do servidor: " + msgErroApi);
      }
      setErroApi(undefined);
      setEstadoErroApi(0);
      setMsgErroApi("");

    }
  }, [erroApi, estadoErroApi])

  useEffect(() => {
    window.scrollTo(0, 0)
    if (tipo)
      setTipoConsulta(tipo)
    else
      setTipoConsulta("");
    limparConsulta();
  }, [tipo]);

  useEffect(() => {
    if (efpcSelecionada) pushToManter(efpcSelecionada, manter);
  }, [efpcSelecionada]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (efpcSelecionadaParaOperacao) pushToEfpcOperacoes();
  }, [efpcSelecionadaParaOperacao]); // eslint-disable-line react-hooks/exhaustive-deps  

  useEffect(() => {
    if (manter > 0 && serieEfpcSelecionadaParaOperacao !== 0)
      getEfpc(serieEfpcSelecionadaParaOperacao);
  }, [manter, serieEfpcSelecionadaParaOperacao]); // eslint-disable-line react-hooks/exhaustive-deps  

  function pushToEfpcOperacoes() {
    let tpSelecao = {
      data: efpcSelecionadaParaOperacao,
    };

    navigate("/" + import.meta.env.VITE_APP_BASE + "/operacao-efpc", { state: tpSelecao });
  }


  function pushToManter(pj: any, manter: number) {
    let tpSelecao = {
      manter: manter,
      data: pj
    };

    navigate("/" + import.meta.env.VITE_APP_BASE + "/efpc-manter", { state: tpSelecao });
  }

  function gerarColunas() {
    let cols: any[] = [];

    cols.push({
      width: 150,
      title: "Código",
      dataIndex: "",
      render: (efpc: IEfpc) => (
        <Input
          value={maskCodigo(efpc.numero)}
          size={"small"}
          style={{ padding: 0 }}
          variant="borderless"
        />
      ),
    });

    cols.push({
      title: "Sigla",
      dataIndex: "sigla",
      width: screens.xs ? 400 : screens.xl ? 300 : 200,
    });

    cols.push({
      // key: "opcoes",
      width: 80,
      title: "Opções",
      dataIndex: "",
      align: 'center' as AlignType,
      render: (efpc: IEfpc) => (
        <>
          <SearchOutlined style={{ color: "blue", display: tipoConsulta === "" ? "none" : "inline" }}
            title="Operações"
            id='detalharOperacaoAutorizacao'
            onClick={() => {
              if (efpc.serie) {
                getEfpc(efpc.serie);
              }
              else {
                errorMessage("Série da Entidade não localizada.");
              }
            }}
          />

          <ExpandAltOutlined style={{ color: "blue", display: tipoConsulta === "" ? "inline" : "none" }}
            // shape="round"
            id='detalhar'
            onClick={() => {
              if (efpc.serie) {
                setManter(2);
                setSerieEfpcSelecionadaParaOperacao(efpc.serie);
              }
              else {
                errorMessage("Série da Entidade não localizada.");
              }
            }}
          />

          <EditOutlined style={{ color: "blue", display: tipoConsulta === "" && hasPermissao([Papel.DILIC_MASTER]) ? "inline" : "none" }}
            id='alterar'
            onClick={() => {
              if (efpc.serie) {
                setManter(3);
                setSerieEfpcSelecionadaParaOperacao(efpc.serie);
              }
              else {
                errorMessage("Série da Entidade não localizada.");
              }
            }}
          />
        </>
      ),
    });
    return cols.filter(Boolean);
  }

  const columns = gerarColunas();

  const validarConsulta = () => {
    getEfpcs();
  };

  const getEfpcs = async () => {
    try {
      setLoading(true);
      setTipLoading("Pesquisando ...");

      const currentForm = form.getFieldsValue();

      const numero = numberOnly(currentForm.numeroEfpc) || "";
      const sigla = currentForm.sigla || "";
      const numeroProcesso = numberOnly(currentForm.numeroProcesso) || "";
      const cnpj = numberOnly(currentForm.cnpjNumero) || "";

      let lQuery = `consulta/dinamica?numero=${numero}&sigla=${sigla}&numero-processo=${numeroProcesso}&cnpj=${cnpj}&page-size=${linhaPorPagina}&page=0`;

      const { data } = await apiEntidade.get(lQuery);
      setLoading(false);

      setEfpcs(data.content);
      setTotalElements(data.totalElements);

      if (data.content.length === 0) {
        infoMessage("O sistema não encontrou resultado para consulta realizada");
      }
    } catch (error: any) {
      let data: IErroApi = error.response.data;
      let msgErro = data.mensagem ? data.mensagem : error.response.data.message;
      let msgDetalheErro = data.campos ? ". " + data.campos[0].cmensagem : "";
      setEstadoErroApi(error.response.status);
      setMsgErroApi(msgErro + msgDetalheErro);
      if (error.response.status < 500) {
        setErroApi(data);
      } else {
        if (error.response.status === 503)
          errorMessage("Servidor remoto não disponível");
        else
          errorMessage(msgErro);
      }
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const handlePaginationChange = async (page: number, pageSize: number) => {
    setLoading(true);

    const currentForm = form.getFieldsValue();


    setPagina(page);
    setLinhaPorPagina(pageSize);

    const numero = numberOnly(currentForm.numeroEfpc) || "";
    const sigla = currentForm.sigla || "";
    const numeroProcesso = numberOnly(currentForm.numeroProcesso) || "";
    const cnpj = numberOnly(currentForm.cnpjNumero) || "";


    let lQuery = `consulta/dinamica?numero=${numero}&sigla=${sigla}&numero-processo=${numeroProcesso}&cnpj=${cnpj}&page-size=${pageSize}&page=${page - 1}`;

    const { data } = await apiEntidade.get(lQuery);

    setEfpcs(data.content);
    setLoading(false);
  };

  const getEfpc = async (serie: number) => {
    try {
      setLoading(true);
      setTipLoading("Pesquisando ...");

      const { data } = await apiEntidade.get(`/ultimo/${serie}/serie`);
      setLoading(false);

      if (manter === 2 || manter === 3) { // DETALHAR OU EDITAR UMA EFPC
        setEfpcSelecionada(data);
      } else { // SELEÇÃO PARA OPERAÇÃO
        setEfpcSelecionadaParaOperacao(data);
      }

      //console.log(data);

      if (!data) {
        infoMessage("O sistema não encontrou resultado para consulta realizada");
      }
    } catch (error: any) {
      errorMessage("Não foi possível realizar a consulta. " + error?.message);
    } finally {
      setLoading(false);
    }
  };


  function limparConsulta() {
    setEfpcs([]);
    setEfpcSelecionada(undefined);
    setTotalElements(0);
    form.resetFields();
  }

  return (
    <Spin spinning={loading} tip={tipLoading}>

      <>
        <h1>{tipoConsulta === "" ? "Consultar Entidade" : "Consultar Entidades - Operação"}</h1>

        <Card>
          <Form layout="vertical" form={form}>
            <Row>
              <Col xs={24} xl={4}>
                <Form.Item
                  label="Código da Entidade"
                  name='numeroEfpc'
                >
                  <Input maxLength={6}
                    onChange={(e) =>
                      form.setFieldsValue({
                        numeroEfpc: maskCodigo(e.target.value),
                      })
                    }
                  />
                </Form.Item>
              </Col>

              <Col xs={24} xl={7}>
                <Form.Item
                  label="Número do Processo"
                  name='numeroProcesso'
                >
                  <Input
                    maxLength={21}
                    onChange={(e) =>
                      form.setFieldsValue({
                        numeroProcesso: maskNumeroProcesso(e.target.value),
                      })
                    }
                  />
                </Form.Item>
              </Col>

              <Col xs={24} xl={7}>
                <Form.Item
                  label="CNPJ"
                  name='cnpjNumero'
                >
                  <Input maxLength={18}
                    onChange={(e) =>
                      form.setFieldsValue({
                        cnpjNumero: maskCnpj(e.target.value),
                      })
                    }
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col xs={24} xl={7}>
                <Form.Item
                  label="Sigla"
                  name='sigla'
                >
                  <Input maxLength={50}
                    onChange={(e) =>
                      form.setFieldsValue({
                        sigla: e.target.value.toUpperCase(),
                      })
                    }
                  />
                </Form.Item>
              </Col>

            </Row>
            <Row justify="end">
              <Space align='center' >
                {
                  <>
                    <Button shape='round' type='primary' icon={<SearchOutlined />} htmlType='button'
                      onClick={() => {
                        validarConsulta();
                      }} >
                      Consultar
                    </Button>
                    <Button disabled={false} shape='round' icon={<ClearOutlined />} htmlType='button'
                      onClick={() => {
                        limparConsulta();
                        window.scrollTo(0, 0)
                      }} >
                      Limpar
                    </Button>
                  </>
                }
              </Space>
            </Row>


          </Form>
        </Card>

        <Card title={"Resultado da consulta - " + totalElements + " encontrados"} style={{ display: totalElements === 0 ? 'none' : 'inline' }}>
          <Table
            // className="overflowConsulta"
            dataSource={efpcs}
            size="middle"
            columns={columns}
            rowKey="serie"
            loading={loading}
            pagination={{
              current: pagina,
              pageSize: linhaPorPagina,
              total: totalElements,
              showSizeChanger: true,
              onChange: handlePaginationChange,
              pageSizeOptions: ["10", "20", "25", "30"],
              locale: { items_per_page: "Linhas por página" },
            }}
            scroll={{ x: "max-content", y: 350 }}
          />
        </Card>
      </>
    </Spin >
  );
};

export default Consultar;
